import React from "react";
import Icon from '@ant-design/icons';

const PendingSVG = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="74" height="70" viewBox="0 0 74 70" fill="currentColor">
        <path d="M30.8,52.5c0-5.7,1.9-11.3,5.5-15.7h-2.7c-7.7,0-14-6.3-14-14c0,0,0,0,0,0V5.2c0-1.8,0.3-3.6,1-5.2h-15
            C2.6,0,0.3,2.3,0.3,5.2c0,0,0,0,0,0v59.5c0,2.9,2.4,5.2,5.3,5.3h32.2C33.2,65.3,30.7,59,30.8,52.5 M52.5,24.3L32,3.7
            c-2-2-3.7-1.3-3.7,1.5v17.5c0,2.9,2.4,5.2,5.3,5.3H51c0.9,0.1,1.8-0.2,2.5-0.8C54,26.5,53.7,25.4,52.5,24.3 M56.3,35L56.3,35
            c-9.7,0-17.5,7.8-17.5,17.5c0,8.6,6.2,15.9,14.6,17.3c0.9,0.2,1.9,0.3,2.9,0.3c9.7,0,17.5-7.8,17.5-17.5v0
            C73.8,42.8,65.9,35,56.3,35C56.3,35,56.3,35,56.3,35 M65,54.7h-8.8c-1.2,0-2.2-1-2.2-2.2v-8.8c0-1.2,1-2.2,2.2-2.2c0,0,0,0,0,0h0
            c1.2,0,2.2,1,2.2,2.2c0,0,0,0,0,0v6.6H65c1.2,0,2.2,1,2.1,2.2C67.1,53.7,66.2,54.7,65,54.7"/>
    </svg>
  )

  const PendingIcon = props => <Icon component={PendingSVG} {...props} />;

  export default PendingIcon;